import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { LeagueSettingsPage, type LeagueSettingsAccess } from './LeagueSettingsPage';
import { GET_FANTASY_LEAGUE_TABS_SHELL } from '../../../graphql/queries/fantasyLeagueTabsShell';
import type {
  GetFantasyLeagueTabsShellQuery,
  GetFantasyLeagueTabsShellQueryVariables,
} from '../../../types/graphql-generated';

// Route wrapper that mounts LeagueSettingsPage as a standalone full-screen page (outside
// the league tab bar). It resolves the current member / admin role from the URL
// so LeagueSettingsPage itself stays a simple prop-driven component.
export const LeagueSettingsPageRoute = () => {
  const leagueId = useParams<'leagueId'>().leagueId!;

  const { data, loading, error } = useQuery<GetFantasyLeagueTabsShellQuery, GetFantasyLeagueTabsShellQueryVariables>(
    GET_FANTASY_LEAGUE_TABS_SHELL,
    { variables: { fantasyLeagueId: leagueId } }
  );

  const currentMember = data?.currentFantasyLeagueMember;

  let access: LeagueSettingsAccess;
  if (loading && !data) {
    access = 'loading';
  } else if (error && !data) {
    access = 'error';
  } else if (!currentMember) {
    access = 'notMember';
  } else {
    access = currentMember.role === 'admin' || currentMember.role === 'creator' ? 'admin' : 'member';
  }

  return (
    <LeagueSettingsPage
      leagueId={leagueId}
      access={access}
      currentMemberId={currentMember?.id}
      currentMemberRole={currentMember?.role}
    />
  );
};
